import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  background-color: white;
  border: 2px solid #d9d9d9;
  border-radius: 8px;
  padding: 24px;
  margin-top: 16px;
  tr:hover > td {
    background-color: unset !important;
  }
`

export const Header = styled.div`
  height: 32px;
  input {
    float: left;
    padding: 4px 8px;
    margin-left: 13px;
    width: 500px;
    border-color: #213f68 !important;
    box-shadow: 0px 0px 0px 4px #213f683d !important;
  }
  input + button {
    opacity: 0;
  }
  button {
    float: left;
    padding: 0 5px;
    color: #757575 !important;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.5;
    }
  }
  button + button {
    float: right;
    border-radius: 8px;
    margin-left: 16px;
    color: #213f68 !important;
  }
  button + button + button {
    padding: 0 13px;
    color: #757575 !important;
    background-color: #f0f0f0 !important;
  }
`

export const Title = styled.div`
  float: left;
  cursor: pointer;
  font-weight: bold;
  color: #213f68;
  padding: 4px 8px;
  margin: 0 3px 0 13px;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: 200ms;
  &:hover {
    opacity: 0.5;
  }
`

interface IContentProps {
  open: boolean
}

export const Content = styled.div<IContentProps>`
  overflow: hidden;
  transition: 200ms;
  .ant-row {
    margin-top: -1px;
    margin-bottom: -32px;
  }
  ${(props) =>
    !props.open &&
    css`
      height: 0;
    `}
`
